import { ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface BasePageLayoutProps {
	children: ReactNode;
	sx?: SxProps<Theme>;
}

/**
 * Base layout wrapper for consistent page structure across the application.
 * Provides standard padding, overflow handling, and flex layout.
 */
export function BasePageLayout({ children, sx = {} }: BasePageLayoutProps) {
	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				p: 3,
				overflow: 'hidden',
				...sx,
			}}
		>
			{children}
		</Box>
	);
}